/**
 * @module Annual Report
 * @description JS for Annual Report Template
 */
import map from './map.js';
import tabset from './tabset.js';
import sliders from './sliders.js';
import tooltip from './tooltip.js';
import bindData from './bind-data.js';
import table from './table.js';
import inContentSlider from './in-content-slide';
import download from './download.js';

const els = {
  map: null,
  tabset: null,
  sliders: null
};

/**
 * @function init
 * @description Kick off this modules functions
 */
const init = () => {
  els.map = document.querySelector( '.interactive-map' );
  els.tabset = document.querySelector( '.ins-annual-report__tabset' );
  els.sliders = document.querySelectorAll( '.selected-region-data__slider' );

  // Bail if we don't have our elements on the page.
  if ( ! els.map || ! els.tabset || els.sliders.length < 1 ) {
    return
  }

  map( els.map );
  tabset( els.tabset, els.map );
  sliders( els.sliders, els.tabset );
  tooltip( els.tabset );
  inContentSlider();
  download();
  
  // We need to give time for field data to get attached to DOM 
  setTimeout( () => {
    bindData( els.map, els.tabset );
    table();
  }, 2000 );
}

init();
